// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__YzuKu","info":"UpdateTermsInfo_info__2-xjc"};